import { useEffect, useMemo, useState } from "react";
import { useScript } from "lib/hooks/useScript";

const JQUERY_JS = "https://code.jquery.com/jquery-3.6.0.min.js";
const JQUERY_UI_JS = "https://code.jquery.com/ui/1.13.1/jquery-ui.min.js";

const useJquery = (needed: boolean) => {
  const jqueryScript = useMemo(() => (needed ? JQUERY_JS : ""), [needed]);
  const jquery = useScript(jqueryScript);
  const jqueryUiScript = useMemo(() => (jquery === "ready" ? JQUERY_UI_JS : ""), [jquery]);
  const jqueryUi = useScript(jqueryUiScript);
  return useMemo(() => jqueryUi === "ready", [jqueryUi]);
};

const useContentAccordion = () => {
  const [needed, setNeeded] = useState(false);
  const [applied, setApplied] = useState(false);
  const jqueryReady = useJquery(needed);
  useEffect(() => {
    const accordionTargets = document.querySelector(".content-accordion");
    setNeeded(accordionTargets != null);
  }, []);
  useEffect(() => {
    if (jqueryReady && !applied) {
      jQuery(".content-accordion").accordion({
        icons: false,
        header: ".content-accordion-header",
        animate: 200,
        heightStyle: "content",
        collapsible: true,
        active: false,
      });
      setApplied(true);
    }
  }, [jqueryReady]);
};
export default useContentAccordion;
